import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useSnackbar } from "notistack";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { checkApiStatus } from "../../../../utils";
import { PermissionWrapper } from "../../../../wrappers";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { ButtonLoader } from "../../../../shared_elements/components";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import InsuranceTypeList from "../components/InsuranceTypeList";
import { deleteInsuranceTypeApi, getInsuranceTypeListApi } from "../apiService";
import InsuranceTypeCRU from "../components/InsuranceTypeCRU";
import SettingPageLayout from "../../../elements/SettingPageLayout";
import { RoleBaseAccess } from "../../../../hoc";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const InsuranceTypeHD=({ createSortHandler, sortInfo, toggleBulkOps, item, bulk })=>{
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Insurance Type`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ width: "200px", whiteSpace: "nowrap"}}>{tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: "200px", whiteSpace: "nowrap"}}>{tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const InsuranceType=()=>{
        const { enqueueSnackbar } = useSnackbar()
        const [isLoading, setLoading] = useState(false)
        const [skeletonLoader, setSkeletonLoader] = useState(false)
        const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
        const [insuranceTypeInfo, setInsuranceTypeInfo] = useState({ list: [], pagination: {} });
        const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
        const [addEditInsuranceType, setAddEditInsuranceType] = useState({ modal: false, data: null, mode: '' });
        const [deleteInsuranceType, setDeleteInsuranceType] = useState({ modal: false, data: null, })
        const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
        const[isExport,seIsExport]=useState(false)
    
    
        useEffect(() => {
            getInsuranceTypeList('skeletonLoader', { per_page: 50 });
            trackActivity('Page Viewed',{ page_title: 'Insurance Type'})
        }, [])
    
        const toggleBulkOps = (flag, type, item) => {
                if (type === 'bulk') {
                    setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
                } else {
                    setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
                }
        }
    
        const createSortHandler = (key) => {
            let sortQuery = { sort_by: key };
            if (sortInfo.sort_by === key) {
                sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
            } else {
                sortQuery = { ...sortQuery, sort: 'asc' }
            }
            setSortInfo(sortQuery)
            getInsuranceTypeList('pageLoader', { ...sortQuery, per_page: insuranceTypeInfo?.pagination?.per_page });
        }
    
        const getInsuranceTypeList = (loaderType, query = {}) => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
            globalGetService(getInsuranceTypeListApi(query)).then(response => {
                if (checkApiStatus(response)) {
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                    setInsuranceTypeInfo(response.data.data);
                }
            })
    
        }
    
        const deleteInsuranceTypeFn = () => {
            setLoading(true);
            const idsToDelete = bulk?.modal ? (bulk?.ids || []).map(item => item?.id) : [deleteInsuranceType?.data?.id];
            globalDeleteService(deleteInsuranceTypeApi(), { ids: idsToDelete } )
                .then(response => {
                    if (checkApiStatus(response)) {
                        trackActivity('Item Deleted', { page_title: `Delete Insurance Type`, success_msg: response?.data?.message, item_ids: deleteInsuranceType?.data || bulk?.ids, response: response?.data })
                        setDeleteInsuranceType({ modal: false, data: null });
                        getInsuranceTypeList('', { per_page: insuranceTypeInfo?.pagination?.per_page });
                        setBulk({ modal: false, ids: [], title: '', type: '' })
                        // setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Deleted', { page_title: `Delete Insurance Type`, error_msg: response?.data?.message, item_ids: deleteInsuranceType?.data || bulk?.ids, response: response?.data })
                    }
                })
        }
    
    
        const handleExport = () => {
            let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
          query = {
            ...query,
            sort: sortInfo?.sort,
            sort_by: sortInfo?.sort_by
          }
        }
            seIsExport(true);
            globalGetService(getInsuranceTypeListApi(query)).then((response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(
                        response?.data.message,
                        { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                    );
                    seIsExport(false);
                }
            })
        }

        const handleItemClicked = (page_type) => {
            trackActivity('Item Clicked', { page_title: `Insurance Type`, page_type: page_type, })
        }
    return (
        <SettingPageLayout
            actionBar={
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'5px 0px' }}>
                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} /> </li>
                    {
                        bulk?.type && bulk?.ids?.length ?
                            <>
                                <li className='lease-mobile-button'>
                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                </li>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['D'] }}>
                                    <li className='lease-mobile-button'>
                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                    </li>
                                </PermissionWrapper>
                            </> : null
                    }
                    {insuranceTypeInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['C'] }}>
                        <li className='lease-mobile-button'>
                            <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { setAddEditInsuranceType({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Insurance Type </Button>
                        </li>
                    </PermissionWrapper>
                </ul>
            }
        >
            <Paper className="lease-detail-table table-container lease-module-paper" elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 138px)', height: insuranceTypeInfo?.list?.length > 0 ? 'calc(100vh - 138px) !important' : 'auto !important' }}>
                <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                    {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                        <Table className='mui-table-format' stickyHeader>
                            <InsuranceTypeHD
                                item={insuranceTypeInfo?.list}
                                bulk={bulk}
                                toggleBulkOps={toggleBulkOps}
                                sortInfo={sortInfo}
                                createSortHandler={createSortHandler} />
                            <TableBody>
                                {insuranceTypeInfo?.list?.length > 0 && insuranceTypeInfo?.list?.map((item, index) =>
                                    <InsuranceTypeList
                                        key={index}
                                        item={item}
                                        bulk={bulk}
                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                        onEditFn={() => setAddEditInsuranceType({ modal: true, data: item, mode: 'edit' })}
                                        onView={() => setAddEditInsuranceType({ modal: true, data: item, mode: 'view' })}
                                        ondeleteFn={() => {
                                            setDeleteInsuranceType({ modal: true, data: item, });
                                            setBulk({ modal: false, ids: [item], title: '', type: '' });
                                        }}
                                        toggleBulkOps={toggleBulkOps}
                                    />
                                )}
                            </TableBody>
                        </Table>
                    )}
                    {!skeletonLoader && insuranceTypeInfo?.list?.length === 0 && <NoRecordFound />}
                </div>
                <Paper square>
                    <Pagination
                        pagination={insuranceTypeInfo?.pagination}
                        onPageChange={(event, newPage) => { const pageNum = newPage + 1; getInsuranceTypeList("pageLoader", { page: pageNum, per_page: insuranceTypeInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getInsuranceTypeList("pageLoader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                    />
                </Paper>
            </Paper>
            {addEditInsuranceType.modal &&
                <InsuranceTypeCRU
                    addEditInsuranceType={addEditInsuranceType}
                    modeType={addEditInsuranceType?.mode}
                    getResponseBack={() => {getInsuranceTypeList("", { per_page: insuranceTypeInfo?.pagination?.per_page }); setBulk({ modal: false, ids: [], title: '', type: '' })}}
                    onToggleModal={() => setAddEditInsuranceType({ modal: false, data: null, mode: '' })}
                />
            }
            {deleteInsuranceType.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal :  deleteInsuranceType.modal}
                    title={ bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (insuranceTypeInfo?.list?.length || 0) ? 'Delete All Insurance Types' : 'Delete Selected Insurance Type') : 'Delete Insurance Type' }
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [] });
                        } else {
                            setDeleteInsuranceType({ modal: false, data: null });
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        }
                    }}
                    onDeleteRecords={() => deleteInsuranceTypeFn()}
                /> : null}
             { revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"delivery_condition"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
            }

            {isLoading ? <PageLoader /> : null}
        </SettingPageLayout>
    )
}

export default RoleBaseAccess(InsuranceType, { application: 'lease_revamp', feature: 'insurance', operationType: ['R'], settingNav: true });
